var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"howItWorks"},domProps:{"innerHTML":_vm._s(_vm.getOrganization.data.block2)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }